/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RootRoutes {
  CONF_USUARIO_NOVA_SENHA_ROUTE = '/confirmar-usuario/:hash/nova-senha',
  CONFIRMAR_USUARIO_FALHA_ROUTE = '/falha-confirmar-usuario',
  CONFIRMAR_USUARIO_ROUTE = '/confirmar-usuario/:hash',
  FORGOT_PW_ROUTE = '/login/redefinir-senha',
  INACTIVITY_ROUTE = '/inatividade',
  LOGIN_ROUTE = '/login',
  NEW_PW_ROUTE = '/nova-senha/:hash',
  REDIRECT_ROUTE = '/prestador',
  ROUTE_CHANGE_PW = '/login/renovar-senha/:nrSeqWSuiteUser',
  ROUTE_PROVIDER = '/prestador',
  ROUTE_SSO_ERROR = '/login-invalido',
  SSO_CALLBACK_ROUTE = '/sso-callback',
  SSO_ROUTE = '/sso',
}
export { RootRoutes };
